import _ from 'lodash';

/**
 * Returns whether a CI (Cedula de Identidad) is valid.
 */
function isCI (value) {
    return !_.isString(value) || value.length < 1 || value.length > 9;
}

export default isCI;
